import React, { useEffect, useState } from 'react';
import Rodal from '../../../components/Rodal/Rodal';
import { ModalBody, ModalHeader } from 'reactstrap';
import './BuyerSelectionPopup.scss';
import { TimelineEvent } from '../../../slices/marketplace/timeline/models/timeline-event.model';
import { EngagementData } from '../../../slices/marketplace/timeline/models/engagement-data.model';
import { EngagementProcess } from '../../../slices/marketplace/timeline/models/engagement-process.model';
import BuyerProfilePreviewPopup from '../../../components/BuyerProfilePreviewPopup/BuyerProfilePreviewPopup';
import {
    BuyerSelectionOptionsList,
    TimelineActionType,
} from '../../../slices/marketplace/timeline/models/timeline-action-type.model';
import { IdNdaSelectionForm } from './IdNdaSelectionForm/IdNdaSelectionForm';
import { FinancialModelSelectionForm } from './FinancialModelSelectionForm/FinancialModelSelectionForm';
import { useStateSelector } from '../../../store/selectors';
import createNotification from '../../../utils/createNotification';
import { useDispatch } from 'react-redux';
import { LoadMarketPlacePricing } from '../../../slices/marketplace/pricing/load-marketplace-pricing.thunk';

interface BuyerSelectionPopupProps {
    isVisible: boolean;
    setIsVisible(value: boolean): void;
    fetchData(): void;
    activeEventId: string;
    events: TimelineEvent[];
    engagementData: EngagementData;
    engagementProcess: EngagementProcess;
    engagementId: number;
}

const BuyerSelectionPopup = (props: BuyerSelectionPopupProps) => {
    const [isBuyerProfilePopupVisible, setIsBuyerProfilePopupVisible] =
        useState(false);
    const [selectedBuyerId, setSelectedBuyerId] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const axios = useStateSelector((state) => state.core.axios);
    const dispatch = useDispatch() as any;

    useEffect(() => {
        dispatch(LoadMarketPlacePricing());
    }, []);

    const renderSelectionForm = () => {
        const targetEvent = props.events.find(
            (event) => event.id === props.activeEventId
        );
        if (!targetEvent) {
            return <></>;
        }
        const action = targetEvent.linkedAction;
        if (
            !action ||
            !BuyerSelectionOptionsList.some((option) => {
                return option.value === action.actionType;
            })
        ) {
            return <></>;
        }
        if (
            action.actionType ===
            TimelineActionType.SellerBuyerSelectionIdNda
        ) {
            return (
                <IdNdaSelectionForm
                    events={props.events}
                    targetEvent={targetEvent}
                    actionId={action.id}
                    engagementData={props.engagementData}
                    engagementProcess={props.engagementProcess}
                    engagementId={props.engagementId}
                    setSelectedBuyerId={setSelectedBuyerId}
                    isLoading={isLoading}
                    onPayAndSendClick={handlePayAndSendClick}
                    onCancelClick={() => {
                        props.setIsVisible(false);
                        props.fetchData();
                    }}
                    setIsBuyerProfilePopupVisible={
                        setIsBuyerProfilePopupVisible
                    }></IdNdaSelectionForm>
            );
        }

        if (
            action.actionType ===
            TimelineActionType.SellerBuyerSelectionDetailedFinancialModel
        ) {
            return (
                <FinancialModelSelectionForm
                    events={props.events}
                    targetEvent={targetEvent}
                    actionId={action.id}
                    engagementData={props.engagementData}
                    engagementProcess={props.engagementProcess}
                    engagementId={props.engagementId}
                    isLoading={isLoading}
                    onPayAndSendClick={handlePayAndSendClick}
                    setSelectedBuyerId={setSelectedBuyerId}
                    onCancelClick={() => {
                        props.setIsVisible(false);
                        props.fetchData();
                    }}
                    setIsBuyerProfilePopupVisible={
                        setIsBuyerProfilePopupVisible
                    }></FinancialModelSelectionForm>
            );
        }
        return <></>;
    };

    const handlePayAndSendClick = (selectedBuyerIds: number[]) => {
        setIsLoading(true);
        axios
            .post(
                `/api/Marketplace/${props.engagementId}/MarketplaceEventActions/Select`,
                { buyerIds: selectedBuyerIds, eventId: props.activeEventId }
            )
            .then((response) => {
                if (response?.request?.status !== 200) {
                    createNotification(
                        'An Error occured during buyer selection.',
                        'error'
                    );
                }
            })
            .finally(() => {
                props.fetchData();
                setIsLoading(false);
                props.setIsVisible(false);
            });
    };

    return (
        <>
            <Rodal
                visible={props.isVisible}
                onClose={() => props.setIsVisible(false)}
                animation="slideUp"
                className="data-nda-terms-popup"
                showMask={true}
                width={650}
                showCloseButton={true}>
                <ModalHeader>
                    <b>Buyer Selection</b>
                </ModalHeader>
                <ModalBody>
                    <div className="buyer-selection-popup body_white_box">
                        {renderSelectionForm()}
                    </div>
                </ModalBody>
            </Rodal>
            {isBuyerProfilePopupVisible ? (
                <BuyerProfilePreviewPopup
                    buyerId={selectedBuyerId}
                    close={() => setIsBuyerProfilePopupVisible(false)}
                />
            ) : (
                <></>
            )}
        </>
    );
};

export default BuyerSelectionPopup;
